import { ForecastOverridesFilter } from 'common/api-types/demand-forecast';
import { LocalizedMessageId } from 'common/types';

import { ForecastOverviewChartLines, OverviewRange } from './types';

export const OVERVIEW_RANGE: OverviewRange[] = ['1W', '2W', '1M', '6M', '1Y', 'MAX'];

export const RANGE_MAP: Record<
  OverviewRange,
  { key: LocalizedMessageId; value: number | undefined }
> = {
  '1W': { key: 'inventory_replenishment.range_week', value: 1 },
  '2W': { key: 'inventory_replenishment.range_week', value: 2 },
  '1M': { key: 'inventory_replenishment.range_month', value: 1 },
  '6M': { key: 'inventory_replenishment.range_month', value: 6 },
  '1Y': { key: 'inventory_replenishment.range_year', value: 1 },
  'MAX': { key: 'inventory_replenishment.range_max', value: undefined },
} as const;

export const CUSTOM_WARNING_COLOR = '#fea90d';

export const FORECAST_OVERVIEW_CHART_LINES: Omit<
  ForecastOverviewChartLines,
  'defaultConfidenceForecast' | 'lowConfidenceForecast' | 'mediumConfidenceForecast'
> = {
  sales: {
    color: '#48B8F7',
    dataKey: 'sales',
    name: 'inventory_replenishment.forecast_last_sales',
    type: 'area',
  },
  imputedSales: {
    color: '#41A6C8',
    dataKey: 'imputedSales',
    name: 'inventory_replenishment.forecast_corrected_sales',
    type: 'line',
  },
  pastFinalForecast: {
    color: '#8A92F5',
    dataKey: 'pastFinalForecast',
    name: 'inventory_replenishment.forecast_last_prediction',
    type: 'line',
  },
  baselineForecast: {
    color: '#95C03C',
    dashed: true,
    dataKey: 'baselineForecast',
    name: 'inventory_replenishment.forecast_baseline_forecast',
    type: 'line',
  },
  finalForecast: {
    color: '#F59E3C',
    dashed: true,
    dataKey: 'finalForecast',
    name: 'inventory_replenishment.forecast_final_forecast',
    type: 'line',
  },
} as const;

export const FORECAST_OVERVIEW_TIME_SERIES_LINES: Omit<
  ForecastOverviewChartLines,
  'sales' | 'imputedSales' | 'pastFinalForecast' | 'baselineForecast' | 'finalForecast'
> = {
  defaultConfidenceForecast: {
    color: '#FF8FE7',
    dashed: true,
    dataKey: 'defaultConfidenceForecast',
    name: 'forecasting.formula_forecast_level:DEFAULT',
    type: 'line',
  },
  lowConfidenceForecast: {
    color: '#FF00C8',
    dashed: true,
    dataKey: 'lowConfidenceForecast',
    name: 'forecasting.formula_forecast_level:LOW',
    type: 'line',
  },
  mediumConfidenceForecast: {
    color: '#B4008D',
    dashed: true,
    dataKey: 'mediumConfidenceForecast',
    name: 'forecasting.formula_forecast_level:MEDIUM',
    type: 'line',
  },
} as const;

export const OVERRIDE_FILTER_OPTIONS: ForecastOverridesFilter[] = [
  'WITH_OVERRIDES',
  'WITHOUT_OVERRIDES',
] as const;
